import React from 'react';
import styled from 'styled-components';
import Location from '../../assets/target.png';
import ReusableDetailCard from '../../components/ReusableDetailCard/ReusableDetailCard';
import Kelp from '../../components/Kelp/Kelp';

const Container = styled.div`
  display: flex;
  flex-direction:column;
  width: 100%;
  border: none;
  border-radius: 9px;
  justify-content: space-around;
  background-color: rgba(0,0,0,0.5);
  backdrop-filter: blur(3px);  
  overflow:hidden;
  box-shadow: 1px 0px 7px rgba(0, 0, 0, 0.5);
  

`;

const Viz = styled.div`
  display: flex;
  width:100%;
  height:50vh;
  justify-content: flex-start;
  align-self:stretch;
  overflow:hidden;
  border-radius: 9px;
  border:none;
  background-color: rgba(0,0,0,0.5);
  position: relative;

  
`;

class CardKelp extends React.Component {
  render () {
   return (

  <Container>
    <Viz>
    
      <Kelp/>       
    
      
            
    </Viz>

      <ReusableDetailCard
   trend= {Location}
   metricsm="Pacific waters, shallow depths"
   diagnosis="Warming water, stronger storms, Over-harvesting. and pollution are taking a toll on the sustainability of kelp forests.These forests provide food and habitat for nearshore ecosystems."
   prediction="Depleted Kelp could damage marine biodiversity, as many fish, invertebrates ans marine mammals depend on the forests for food and shelter (NOAA)."
   significanceorthreat="SIGNIFICANCE"
   confidence="CONFICENCE LV: 95%"
   />
  </Container>
  );
 }
}

export default CardKelp;
